import React from 'react';
import NavigationBar from '../nav_bar/navigation_bar';
import Footer from '../footer/footer';
import HomePage from '../home/home_page';

const Home = () => {
    return (
        <div className="home-page">
            <NavigationBar />

            <main className="home-main">
                <section id="home" className="home-section">
                    <HomePage />
                </section>
            </main>

            <Footer />
        </div>
    );
};

export default Home;